module.exports = __webpack_public_path__ + "6ea6b0606dd10a8589729896e0237d14.jpg";